"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinStyled = exports.PinButton = exports.InputWrapper = exports.GoogleMapReactWrapper = exports.Geosuggest = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactGeosuggest = _interopRequireDefault(require("react-geosuggest"));
var _icons = require("../icons");
var _styles = require("../../shared/styles");
var _selectors = require("../../shared/styles/themes/selectors");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Geosuggest = exports.Geosuggest = (0, _styledComponents["default"])(_reactGeosuggest["default"]).attrs({
  style: {
    input: {
      position: 'relative',
      backgroundColor: 'transparent',
      zIndex: 102,
      width: '100%',
      padding: '10px',
      paddingRight: '50px'
    },
    suggests: {
      zIndex: 101,
      backgroundColor: '#fff',
      position: 'absolute',
      overflow: 'scroll',
      //   maxHeight: '250px',
      width: '100%'
    },
    suggestItem: {
      listStyle: 'none',
      cursor: 'pointer',
      color: 'black'
    }
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  background-color: transparent;\n  ", ";\n\n  .geosuggest__input {\n    ", "\n    background-color: transparent;\n    border: none;\n    border-bottom: 2px solid ", ";\n    color: ", ";\n  }\n\n  .geosuggest__suggests-wrapper {\n    width: 100%;\n    position: relative;\n  }\n\n  .geosuggest__item {\n    ", "\n    ", "\n    \n    &:hover {\n      background: ", ";\n    }\n  }\n\n  .geosuggest__suggests--hidden {\n    max-height: 0 !important;\n    overflow: hidden !important;\n    border-width: 0 !important;\n    padding: 0 !important;\n  }\n"])), (0, _styles.margin)('m', 'bottom'), (0, _styles.fontSize)('base'), _selectors.formBorderColor, _selectors.color, (0, _styles.padding)('s'), (0, _styles.fontSize)('base'), _styles.color.orange);
var PinStyled = exports.PinStyled = (0, _styledComponents["default"])(_icons.Pin)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  color: ", ";\n"])), _selectors.primaryAccentColor);
var InputWrapper = exports.InputWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var PinButton = exports.PinButton = (0, _styledComponents["default"])(_icons.Pin)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  z-index: 103;\n  cursor: pointer;\n  position: absolute;\n  bottom: 8px;\n  right: 0;\n  padding: 0 5px 0 10px;\n  width: 40px;\n  border-left: 2px solid ", ";\n"])), _selectors.color);
var GoogleMapReactWrapper = exports.GoogleMapReactWrapper = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  height: 250px;\n"])), (0, _styles.margin)('m', 'bottom'));